export const StatusEnum = Object.freeze({
  ACTIVE: true,
  INACTIVE: false,
});
